import { render } from "./Home.vue?vue&type=template&id=5e9f15b0&ts=true"
import script from "./Home.vue?vue&type=script&lang=ts"
export * from "./Home.vue?vue&type=script&lang=ts"

import "./Home.vue?vue&type=style&index=0&id=5e9f15b0&lang=css"

import exportComponent from "/Users/ra1to/Desktop/web_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__